import { ComboBox as EJ2ComboBox } from '@syncfusion/ej2-dropdowns';
import { Base } from './base-module';
/**
 * The `ComboBox` module is used configure the properties of Combo box type editor.
 */
export class ComboBox {
    constructor(parent) {
        this.compObj = undefined;
        this.parent = parent;
        this.parent.comboBoxModule = this;
        this.base = new Base(this.parent, this);
    }
    render(e) {
        this.compObj = new EJ2ComboBox(this.parent.model);
        this.compObj.appendTo(e.target);
    }
    focus() {
        this.compObj.element.focus();
    }
    /**
     * @hidden
     * @returns {void}
     */
    showPopup() {
        this.compObj.focusIn();
        this.compObj.showPopup();
    }
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.base.destroy();
    }
    updateValue(e) {
        if (this.compObj && e.type === 'ComboBox') {
            this.parent.setProperties({ value: this.compObj.value }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */
    getModuleName() {
        return 'combo-box';
    }
}
